import type { HTMLAttributes, ReactNode, Ref } from 'react'

import { cn } from '@gto/ui/cn'

import styles from './button-group.module.css'
import { buttonGroupVariants } from './button-group.styles'

type ButtonGroupProps = {
  children: ReactNode
  className?: string
  ref?: Ref<HTMLDivElement>
  'data-tst'?: string
} & Omit<HTMLAttributes<HTMLDivElement>, 'children' | 'className'>

const ButtonGroup = ({ children, className, ref, ...props }: ButtonGroupProps) => {
  return (
    <div
      ref={ref}
      className={cn(styles.root, buttonGroupVariants(), className)}
      role="group"
      {...props}
    >
      {children}
    </div>
  )
}

export { ButtonGroup }
export type { ButtonGroupProps }
